// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconSaveHeart = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 24', fill: 'none', ...props },
    <g clipPath="url(#icon-save-heart_svg__clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.777 12.198L12.004 22.73 22.23 12.198a5.916 5.916 0 001.134-6.895 6.095 6.095 0 00-9.691-1.552l-1.67 1.523-1.67-1.523A6.094 6.094 0 00.642 5.303a5.914 5.914 0 001.135 6.895zm.201-6.213a4.414 4.414 0 00.849 5.142l.013.013 9.164 9.437 9.163-9.437.013-.013a4.416 4.416 0 00.85-5.141 4.595 4.595 0 00-7.305-1.166l-.02.02-2.701 2.464L9.302 4.84l-.02-.02a4.594 4.594 0 00-7.304 1.165z"
        fill="currentColor"
      />
    </g>,
    <defs>
      <clipPath id="icon-save-heart_svg__clip0">
        <path fill="#fff" transform="translate(.004)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  );
export default SvgIconSaveHeart;
